const BulbOnIcon = (props) => (
	<svg xmlns="http://www.w3.org/2000/svg"
		width="24" height="24" viewBox="0 0 24 24"
		fill="currentColor"
		{...props}
	>
		<path d="M12 19C13.5913 19 15.1174 18.3679 16.2426 17.2426C17.3679 16.1174 18 14.5913 18 13C18 10.78 16.79 8.84 15 7.8V6C15 5.73478 14.8946 5.48043 14.7071 5.29289C14.5196 5.10536 14.2652 5 14 5H10C9.73478 5 9.48043 5.10536 9.29289 5.29289C9.10536 5.48043 9 5.73478 9 6V7.8C7.21 8.84 6 10.78 6 13C6 14.5913 6.63214 16.1174 7.75736 17.2426C8.88258 18.3679 10.4087 19 12 19M14 4V3C14 2.73478 13.8946 2.48043 13.7071 2.29289C13.5196 2.10536 13.2652 2 13 2H11C10.7348 2 10.4804 2.10536 10.2929 2.29289C10.1054 2.48043 10 2.73478 10 3V4H14ZM20 14H23V12H20V14ZM1 14H4V12H1V14ZM13 24V21H11V24H13ZM4.92 21.5L7.05 19.36L5.63 17.95L3.5 20.07L4.92 21.5ZM16.95 19.37L19.07 21.5L20.5 20.07L18.37 17.95L16.95 19.37Z" />
	</svg>
)

export default BulbOnIcon